import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withAuth } from '../AuthContext';
import MyTable from './MyTable';

class PostPhoto extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            postId: null,
            alid: true,
            errorText: '',
            imagePath: '',
            images: null,
            headings: [
                "id", "name"
            ],
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.redirect = this.redirect.bind(this);

    }

    redirect(){
        // this.loadData();
        this.props.history.push(`/admin/dashboard/posts/${this.state.postId}/upload`);

    }

    handleChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    loadData() {

        let postId = this.props.match.params.id;
        this.setState({ postId });

        const headers = {
            'Content-Type': 'application/json'
        };

        return axios
            .get(`/api/blog/${postId}`, headers)
            .then(response => {
                let data = response.data.data;
                this.setState({
                    images: data.images,
                    imagePath: data.images[0].name
                });
            })
            .catch(function(error) {
                console.log('Request failure: ', error);
            });
    }

    componentDidMount(){
        this.loadData();
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ valid: true, errorText: '' });

        const formData = new FormData();
        formData.append('file', this.state.file);
        const headers = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        axios
            .post(`/api/blog/${this.state.postId}/upload-photo`, formData, headers)
            .then(response => {
                this.props.history.push(`/admin/dashboard/posts/${this.state.postId}/upload`);
            })
            .catch(err => {
                this.setState({
                    valid: false,
                    errorText:
                        'Upload failed. Please ensure the file size is less than 6 MB'
                });
            });
    }

    render() {
        const { imagePath, images, headings } = this.state;

        let imagesTable = "";
        let imageHtml = "";

        if(images){
            imagesTable = (<MyTable headings={headings} data={images} url={`blog/delete-photo`} isDelete={true} deleteRedirect={this.redirect} hideViewEdit={true} actions={true} imageUpload={false} />);
        }

        if(imagePath){
            imageHtml = (<img
                className="img-fluid"
                src={`${s3AwsEndpoint}/${imagePath}`}
            />);
        }

        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="title">Post photo</h3>
                                <form
                                    method="POST"
                                    action="/"
                                    name="myForm"
                                    aria-label="Verify photo"
                                    onSubmit={event => {
                                        event.preventDefault();
                                        this.handleSubmit(event);
                                        return false;
                                    }}>
                                    <input
                                        type="hidden"
                                        name="csrf-token"
                                        value={window.Laravel.csrfToken}
                                    />

                                    <div className="profile-wrapper">
                                        <div className="col-12  form-group">
                                            <label>Upload photo</label>
                                        </div>
                                        <div className="col-12  form-group">
                                            <input type="file" onChange={this.handleChange} />
                                        </div>
                                        <div
                                            className="col-12 form-group"
                                            style={{
                                                visibility: this.state.valid ? 'hidden' : 'visible'
                                            }}>
                                            <label style={{ color: 'red' }}>
                                                {this.state.errorText}
                                            </label>
                                        </div>
                                        <div className="col-12  form-group">
                                            <button type="submit" className="btn btn-primary">
                                                Upload
                                            </button>
                                            <p>
                                                Ensure your photo is clear and recognisable PNG, GIF,
                                                JPEG or JPG smaller than 6MB are allowed to upload
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {imagesTable}

                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(PostPhoto));
